import { toast } from 'sonner'

import { Button } from 'slab'

interface ClickableExternalLinkProps {
  url: string
  label?: string
  showCopyButton?: boolean
  className?: string
  codeClassName?: string
}

function ClickableExternalLink ({
  url,
  label,
  showCopyButton = true,
}: ClickableExternalLinkProps) {
  const handleUrlClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(url)
      toast.success('URL copied to clipboard!')
    } catch (error) {
      console.error('Failed to copy URL:', error)
      toast.error('Failed to copy URL')
    }
  }

  return (
    <div className='text-sm text-blue-700'>
      {label && <p className='mb-1'>{label}</p>}
      <div className='flex items-center gap-2'>
        <code
          className='flex-1 bg-white border border-blue-300 rounded px-2 py-1 text-xs cursor-pointer hover:bg-blue-50'
          onClick={handleUrlClick}
          title='Click to open in new window'
        >
          {url}
        </code>
        {showCopyButton && (
          <Button
            variant='secondary'
            size='small'
            onClick={handleCopyUrl}
          >
            Copy
          </Button>
        )}
      </div>
    </div>
  )
}

export default ClickableExternalLink
